import React from 'react';
import CriteriaTab from './CriteriaTab';

interface Page {
  name: string;
  title: string;
  questions: any[];
  getType?: () => string;
  isEmpty?: () => boolean;
}

interface Model {
  currentPage: Page;
  visiblePages: Page[];
}

interface CriteriaSectionProps {
  model: Model;
  sectionId: number;
  onPageChanged: (page: Page) => void;
}

const CriteriaSection: React.FC<CriteriaSectionProps> = ({
  model,
  sectionId,
  onPageChanged,
}) => (
  <>
    {model.visiblePages
      .filter((page) => page.name.startsWith(`${sectionId}_`))
      .map((page) => (
        <CriteriaTab
          key={page.name}
          isCurrent={model.currentPage.name === page.name}
          page={page}
          onTabClick={onPageChanged}
        />
      ))}
  </>
);

export default CriteriaSection;
